<div *ngIf="showBioScreen == true" class="compleate_overlay">
  <img [src]="themeImage" alt="">
</div>
<form name="user" #user="ngForm" (ngSubmit)="submit(user)">
  <div *ngIf="failedAttempts > 0" class="ab-red failed-attempts">
    <span [class.invisible]="failedAttempts < 2" transloco="failedAttempts"></span>
  </div>

  <div class="input-container">
    <label class="input-label required" for="username" transloco="email">Email</label>
    <input type="email" name="username" id="username" #username="ngModel" ngModel required email
          (change)="failedAttempts=0">
    <div class="input-error">
      <span *ngIf="username.invalid && username.dirty" transloco="textError"></span>
    </div>
  </div>
  <div class="input-container">
    <div style="display: flex;">
      <label style="flex:1;" class="input-label required" for="password" transloco="password">Password</label>
      <a style="flex: 1; text-align: right; text-transform: none;" class="input-label" routerLink="/recovery" transloco="forgotPassword">Forgot password?</a>
    </div>
    <input type="password" showPassword name="password" id="password" #password="ngModel" ngModel required
          autocomplete="current-password">
    <div class="input-error">
      <span *ngIf="password.invalid && password.dirty" transloco="passwordError"></span>
    </div>
  </div>

  <div class="input-container" *ngIf="mfaRequired">
    <input name="mfa_code" type="text" [(ngModel)]="mfaCode" inputmode="numeric" mask="000000" autofocus>
    <label transloco="mfaCode">MFA Code<span class="asterisk">*</span></label>
  </div>

  <button class="ab_button filled adjusted mt-5" transloco="logIn" type="submit" [loading]="loading">Log In</button>

</form>
